import React from 'react';
import { ErrorImgWrapper, ErrorTextWrapper } from './ErrorComponent.styles';
import ErrorImg from './ErrorImg';
/**
 * ErrorComponent
 * @public
 */
const ErrorComponent = () => {
  return React.createElement("div", null, React.createElement(ErrorImgWrapper, {
    "data-testid": 'error-img-wrapper'
  }, React.createElement(ErrorImg, null)), React.createElement(ErrorTextWrapper, {
    bg: 'warning.light',
    mx: 3,
    borderRadius: 12,
    py: 2,
    px: 12,
    "data-testid": 'error-text-wrapper'
  }, React.createElement("span", null, "Lost in the Clouds. "), " We're sorry, something seems to have gone wrong. Please try again in a little bit."));
};
export default ErrorComponent;